import { createAction, handleActions } from 'redux-actions';

const defaultState = {
  data: null,
  permissions: [],
  isLoading: false,
  error: null
};

// User data actions
export const setUser = createAction('CORE/USER/SET_USER');
export const clearUser = createAction('CORE/USER/CLEAR_USER');
export const setUserLoading = createAction('CORE/USER/SET_LOADING');
export const setUserError = createAction('CORE/USER/SET_ERROR');

// User permissions actions
export const setUserPermissions = createAction('CORE/USER/SET_PERMISSIONS');
export const clearUserPermissions = createAction('CORE/USER/CLEAR_PERMISSIONS');
export const setPermissionsLoading = createAction('CORE/USER/SET_PERMISSIONS_LOADING');
export const setPermissionsError = createAction('CORE/USER/SET_PERMISSIONS_ERROR');

export const reducer = handleActions(
  {
    [setUser]: (state, action) => ({
      ...state,
      data: action.payload,
      permissions: (action.payload && action.payload.permission_tokens) || state.permissions,
      error: null
    }),
    [clearUser]: (state) => ({
      ...state,
      data: null,
      permissions: [],
      error: null
    }),
    [setUserLoading]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [setUserError]: (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false
    }),
    [setUserPermissions]: (state, action) => ({
      ...state,
      permissions: action.payload || [],
      error: null
    }),
    [clearUserPermissions]: (state) => ({
      ...state,
      permissions: []
    }),
    [setPermissionsLoading]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [setPermissionsError]: (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false
    })
  },
  defaultState
);

export default {
  setUser,
  clearUser,
  setUserLoading,
  setUserError,
  setUserPermissions,
  clearUserPermissions,
  setPermissionsLoading,
  setPermissionsError,
  reducer
};
